import { utils } from '../../utils';

class UserService {
	constructor() {
		if (UserService._instance) {
			return UserService._instance;
		}

		this.userObjectCallbacks = [];

		UserService._instance = this;
	}

	/**
	 * Adds callback_ to an internal array, that starts with index 1.
	 * If priority_ is true, callback_ is stored at index 0.
	 * So when it comes to merging the data returned by every registered callback, the priority one goes first.
	 * @param {Function} callback_ - adds data to the user tracking by returning them as Object or Array
	 * @param {boolean} priority_ - indicates the default callback
	 * @returns {void}
	 */
	register(callback_, priority_ = false) {
		if (typeof callback_ !== 'function') {
			throw new Error('bad parameter: callback_ is not of type function');
		}

		const index =
			this.userObjectCallbacks.length === 0
				? 1
				: this.userObjectCallbacks.length;

		if (priority_) {
			this.userObjectCallbacks[0] = callback_;
		} else {
			this.userObjectCallbacks[index] = callback_;
		}
	}

	/**
	 * The counterpart to register().
	 * @param {Function} callback_ - adds data to the user tracking by returning them as Object or Array
	 * @returns {void}
	 */
	unregister(callback_) {
		let index = this.userObjectCallbacks.indexOf(callback_);

		if (index !== -1) {
			this.userObjectCallbacks.splice(index, 1);
		}
	}

	/**
	 * Collect the user tracking data from callbacks
	 * @returns {Promise<Array>} - Promise that evaluates to user tracking data
	 */
	async getData() {
		const userObjects = await this._getRegisteredUserObjects();
		const mergedUserObject = utils.mergeObjects(...userObjects);

		return mergedUserObject;
	}

	/**
	 * _getRegisteredCartObjects - collects the tracking data of all registered objects
	 * @returns {Array} returns array of cart objects
	 */
	async _getRegisteredUserObjects() {
		let userObjects = [];

		for (const callback in this.userObjectCallbacks) {
			if (callback && this.userObjectCallbacks[callback]) {
				const tempObject = await this.userObjectCallbacks[callback]();
				userObjects.push(tempObject);
			}
		}

		return userObjects;
	}
}

/**
 * Singleton instance
 * @type {UserService}
 * @private
 * @static
 */

const userService = new UserService();

export { userService, UserService };
